'use client';

import { useState } from 'react';
import Styles from './mobile-order-summary.module.scss';
import { ISalesOrderResponse } from '~/interfaces/get-sales-order';

const MobileOrderSummary: React.FC<{
  orderDetails: ISalesOrderResponse;
  children?: React.ReactNode;
}> = ({ orderDetails, children }) => {
  const [expanded, setExpanded] = useState(false);

  if (!orderDetails) {
    return <div>Failed to load order summary.</div>;
  }

  const toggle = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <div id="showOrderSummary" className={Styles.mobileOnly}>
      <div id="collapsibleContainer">
        <button
          className={Styles.toggleButton}
          aria-label="Show order summary"
          aria-expanded={expanded}
          aria-controls="orderSummaryContent"
          onClick={toggle}
        >
          Show order summary
          <span className={expanded ? Styles.rotateChevron : Styles.tgtChevron}>
            {'>'}
          </span>
        </button>

        <div
          id="orderSummaryContent"
          className={`${Styles.collapsibleContent} ${
            expanded ? Styles.open : ''
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default MobileOrderSummary;
